module.exports = __webpack_public_path__ + "img/CH01-026-027.235cf1d1.jpg";